import devConfig from './config.development'
import prodConfig from './config.production'

export default process.env.REACT_APP_ENVIRONEMT === 'production'
  ? prodConfig
  : devConfig
